import {ApiProvider} from "./ApiProvider";
import {forEach} from 'lodash';
import {mockEnvironment} from "../../app";

class request {
    constructor() {
        this.provider = ApiProvider.create();
    }

    get(url, params) {
        this._classifyApi();
        const requestParams = params && params.params;
        const options = params && params.options;

        return this.provider({
            method: 'GET',
            url: this._prepareRequestUrl(url, params),
            params: requestParams || null,
            ...options
        });
    }

    post(url, params) {
        this._classifyApi();
        const requestParams = params && params.params;
        const options = params && params.options;
        const data = params && params.data;

        return this.provider({
            method: 'POST',
            url,
            data,
            params: requestParams || null,
            ...options,
        })
    }

    /** @private */
    _classifyApi() {
        if (mockEnvironment.isMocked) {
            this.provider = ApiProvider.create({baseUrl: mockEnvironment.classifyApi()})
        }
    }

    /** @private */
    _prepareRequestUrl(url, params) {
        forEach(params, (value, key) => {
            url = url.replace(`%${key}%`, value);
        });

        return url;
    }
}

export const Request = new request();
